import Logo from "@/components/Logo";
import { scrollToId } from "@/App";

const COLS = [
  {
    title: "Services",
    links: [["Document Printing", "services"], ["Spiral & Wiro Binding", "services"], ["Thesis Hard Cover", "services"], ["Staple & Pin", "services"]],
  },
  {
    title: "Explore",
    links: [["Pricing", "pricing"], ["How it works", "process"], ["About", "about"], ["FAQ", "faq"], ["Gift Catalog", "/catalog"]],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-edge bg-surface/40" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Logo />
          <p className="mt-6 text-sm text-mist leading-relaxed max-w-xs">
            Express document printing and binding for Mumbai&apos;s businesses,
            students and institutions. Printed right, delivered fast.
          </p>
        </div>
        {COLS.map((col) => (
          <div key={col.title} className="md:col-span-2">
            <h4 className="font-mono text-[10px] uppercase tracking-[0.3em] text-mist mb-5">{col.title}</h4>
            <ul className="space-y-3">
              {col.links.map(([label, id]) => (
                <li key={label}>
                  {String(id).startsWith("/") ? (
                    <a
                      href={id}
                      data-testid={`footer-route-link-${label.split(" ")[0].toLowerCase()}`}
                      className="text-sm text-paper/80 hover:text-cyanbrand transition-colors"
                    >
                      {label}
                    </a>
                  ) : (
                    <button
                      data-testid={`footer-${id}-link-${label.split(" ")[0].toLowerCase()}`}
                      onClick={() => scrollToId(id)}
                      className="text-sm text-paper/80 hover:text-cyanbrand transition-colors text-left"
                    >
                      {label}
                    </button>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
        <div className="md:col-span-3">
          <h4 className="font-mono text-[10px] uppercase tracking-[0.3em] text-mist mb-5">Visit</h4>
          <p className="text-sm text-paper/80 leading-relaxed">
            Unit 16, Neelkanth Udhyog Bhavan,
            <br /> Opp 72 Corp, Sakivihar Road, Sakinaka,
            <br /> Andheri East, Mumbai, Maharashtra 400072
          </p>
          <p className="mt-3 text-sm text-paper/80">+91 70215 04681</p>
          <p className="text-sm text-paper/80">ppsllp2026@gmail.com</p>
          <p className="mt-3 font-mono text-[11px] text-mist">Mon–Sat · 9:30 AM – 8:00 PM</p>
        </div>
      </div>

      <div className="border-t border-edge">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-mono text-[11px] text-mist/70">© 2026 PRO PRINT SOLUTION LLP. All rights reserved.</p>
        </div>
      </div>

      <div className="overflow-hidden select-none" aria-hidden="true">
        <p className="font-display font-bold tracking-tight text-[13vw] leading-none text-center text-paper/[0.04] -mb-[2.5vw] whitespace-nowrap">
          PRO PRINT
        </p>
      </div>
    </footer>
  );
}
